import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { FormService } from '../shared/dhl-form/services/form.service'
import { ModalService } from '../common/modal/modal.service';
import { APP_Constants } from 'src/app/app.constant';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { Modal } from 'src/app/common/modal/modal';

import { AbstractControl, UntypedFormControl, UntypedFormArray, UntypedFormGroup, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { DhlFormControlEventData } from '../common/models/dhl-form-control-event-data';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
import { ConvertUomPipe } from 'src/app/common/convert-uom.pipe';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import moment from 'moment';
import { HttpParams } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class AlphaService {
    isLoading: boolean = false;
    durationInSeconds = 20;
    private keepAffectedColumnValues;
    keys: string[];
    volCalculation: any;
    multilevelformGroup: FormGroup<any>;
    configDataControls: any = {};
    isFileUpload: boolean = false;
    intervalId: any;  
    private documentIds: string[] = [];
    refreshTocken: string;

    constructor(private appService: AppService, public formService: FormService, private modalService: ModalService, private _snackBar: CustomSnackBarService,private ConvertUomPipe:ConvertUomPipe, public confirmMatDialog: MatDialog) { }

    groupValidationsFields: { fields: string[]; errorMessage: string;}[] = [];

    //Start Delete API will be called whenever an order is created from a draft order.
    deleteDraftOrder(prefrenceId) {
        this.isLoading = true;
        this.modalService.closeModel();
        let apiUrl = APP_Constants.DELETE_DRAFT_ORDER + localStorage.getItem('customerCode') +
            '&userId=' + localStorage.getItem('userName') +
            '&preferenceId=' + prefrenceId;
        this.appService.makeHttpDeleteRequest(apiUrl)
            .subscribe(data => {
                if (data?.['message']?.statusCode === 'ERROR') {
                    this.normalView();
                    this.isLoading = false;
                    let errormsg = this.appService.errorHandling(data['message']);
                    let modal = new Modal({
                        action: false, name: 'orderCancelInvalid', title: 'Draft Order Delete', description: errormsg, actionButtonText: ''
                    });
                    this.modalService.createModalBox(modal, data['message'].statusCode);

        } else if (data?.['message']?.statusCode === 'FAILED') {
          this.normalView();
          this.isLoading = false;
          this._snackBar.open({ message: data['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
        }
      }, err => {
      	this.normalView();
      	this.isLoading = false;
      	let modal = new Modal({
          action: false, name: 'orderCancel', title: "Draft Order Delete", description: err.message, actionButtonText: ''
    	});
        this.modalService.createModalBox(modal, err.status);
      });
    }
    //End

    //Loading icon display none
    normalView() {
        document.getElementById("overlay").style.display = "none";
    }
    //end

    compareValues(key, value, configData = null) {
      let isMatch = false;
      if (configData?.component == 'GENERIC_AUTOCOMPLETE_V2') {
        isMatch = key.includes(value?.primaryValue);
      } else if (!Array.isArray(value) && value?.value) {
        isMatch = key.includes(value?.value);
      } else if (Array.isArray(value)) {
        value.forEach((el) => {
          if (key.includes(el.value)) isMatch = true;
      });
    } else if (Array.isArray(key) && !Array.isArray(value) && typeof value === 'object') {
      isMatch = key.some((item) => {
        return typeof item === 'object' && !Array.isArray(item) && Object.keys(item).every((k) => {
          const itemValue = typeof item[k] === 'string' ? item[k].trim() : item[k];
          const valueValue = typeof value[k] === 'string' ? value[k].trim() : value[k];
          return itemValue === valueValue;
        });
      });
      } else {
        isMatch = key.includes(value);
      }
      return isMatch;
    }
    
      isRequired(field, frmGroup) {
        if (field.required && !frmGroup.get(field.name)['hidden']) {
          frmGroup.get(field.name)['required'] = true;
          frmGroup.get(field.name).addValidators([Validators.required])
        } else {
          frmGroup.get(field.name)['required'] = false;
          frmGroup.get(field.name).removeValidators([Validators.required])
        }
      }
      
      isReset(field, frmGroup) {
        frmGroup.get(field.name)?.setErrors(null);
        frmGroup.get(field.name)?.reset();
        if (field?.reset && field?.resetRequired) {
          frmGroup.get(field.name)?.setValue([]);
        } else {
          frmGroup.get(field.name)?.setValue("");
        }
    } 

    setLocationDraftOrder = (dataObj) => {

    let selectedLocation = {};
    selectedLocation['origin'] = {};
    selectedLocation['destination'] = {};

    selectedLocation['origin']['addressLine'] = dataObj?.sourceLocationAddressLine || '';
    selectedLocation['origin']['provinceCode'] = dataObj?.sourceLocationProvinceCode || '';
    selectedLocation['origin']['postalCode'] = dataObj?.sourceLocationPostalCode;
    selectedLocation['origin']['city'] = dataObj?.sourceLocationCity || '';
    selectedLocation['origin']['locationName'] = dataObj?.sourceLocationName|| '';
    selectedLocation['origin']['countryCode'] = dataObj?.sourceLocationCountryCode || '';
    selectedLocation['origin']['latitude'] = dataObj?.mapData?.start?.lat || '';
    selectedLocation['origin']['longitude'] = dataObj?.mapData?.start?.lng || '';
    selectedLocation['origin']['importEU'] = dataObj?.sourceImportEU || '';
    selectedLocation['origin']['locationId'] = dataObj?.originId || '';

    selectedLocation['destination']['addressLine'] = dataObj?.destinationLocationAddressLine;
    selectedLocation['destination']['provinceCode'] = dataObj?.destinationLocationProvinceCode;
    selectedLocation['destination']['postalCode'] = dataObj?.destinationLocationPostalCode;
    selectedLocation['destination']['city'] = dataObj?.destinationLocationCity;
    selectedLocation['destination']['locationName'] = dataObj?.destinationLocationName;
    selectedLocation['destination']['countryCode'] = dataObj?.destinationLocationCountryCode;
    selectedLocation['destination']['latitude'] = dataObj?.mapData?.finish?.lat || '';
    selectedLocation['destination']['longitude'] = dataObj?.mapData?.finish?.lng || '';
    selectedLocation['destination']['importEU'] = dataObj?.destinationImportEU || '';
    selectedLocation['destination']['locationId'] = dataObj?.destinationId || '';

    let storeObj = JSON.stringify(selectedLocation);
    localStorage.setItem("selectedLocation", storeObj);

  }

    formatOrderListData(tableHeaders, orders, dateFormattedColumns?) {
      let primaryText = '';
      let number = 0;
      this.appService.applydateformat(tableHeaders,orders,dateFormattedColumns);
      orders.map(data => {
        tableHeaders.some(columnList => {
          // console.log("Primary TExt::",columnList['primaryText']);
          // console.log("Primary TExt Value::",columnList['primaryText'].value);
          if(columnList['primaryText'].multipleValue && columnList['primaryText'].multipleValue.length > 0)
          {
            columnList['primaryText'].value = columnList['primaryText'].multipleValue;
          }
          columnList['primaryText'].value && columnList['primaryText'].value.forEach(col1 => {
            if (columnList['primaryText'].type === "object") {
              col1.value.forEach(tdcol => {
                if (primaryText.length > 0) {
                  if (columnList['primaryText'].value.length > 2)
                    primaryText += ', ';
                  else
                    primaryText += ' ';
                }
                if (col1.multipleNode) {
                  let node = col1.split(',');
                  let value;
                  for (var x in node) {
                    if (value)
                      value = value[node[x]];
                    else
                      value = data[node[x]];
                  }
                  primaryText += value;
                } else {
                  if (col1 === 'serialNumber')
                    primaryText += ++number;
                  else
                    primaryText += data[tdcol];
                }
              });
              if (col1.suffix && primaryText) {
                primaryText += ' ' + col1.suffix;
              }
              data[col1.key] = primaryText;
              // start sorting on raw value
              let raw;
              raw = primaryText.split(" ")[0];
              if (columnList['sortColumnAttribute'].type === 'integer')
                raw = parseInt(raw)
              data["raw_" + col1.key] = raw;
              primaryText = ''
            }
          })
        });
      }, this)
      return orders;
    }


  //volume calculation
  fieldValidationForVolumeCalculation(frmGroup) {
      var outputVol = Object.values(frmGroup).every(value => {
        if (value === "" || value === null) {
          return false;
        } else {
          return true
        }
      });
    return outputVol;
  }
  //end
  
 //volume calculation
 volumeCalculation(eventData: DhlFormControlEventData) {
  delete eventData.data.volume;
  delete eventData.data.weight;
  delete eventData.data.uomWeight;
  delete eventData.data.handling_unit
  delete eventData.data.stackable

  if(eventData.configData.isAutoPopulateRequired){
    this.appService._components['length'].frmGroup.get('length').setValue(eventData.eventData.LENGTH)
    this.appService._components['width'].frmGroup.get('width').setValue(eventData.eventData.WIDTH)
    this.appService._components['height'].frmGroup.get('height').setValue(eventData.eventData.HEIGHT)
  }

  
  this.keys = Object.keys(eventData.data)
      for (let prop in this.keys) {
        let val = this.appService._components[this.keys[prop]].frmGroup.get(this.keys[prop]).value
        eventData.data[this.keys[prop]] = val;
      }
      this.volCalculation = this.fieldValidationForVolumeCalculation(eventData.data)
      if (this.volCalculation) {
        let url = APP_Constants.VOLUME_CALCULATION + eventData.event+"&customerCode="+ localStorage.getItem('customerCode') + '&userId=' + localStorage.getItem('userName');
        this.appService.makeHttpPostRequest(url, eventData.data).subscribe((response: any) => {
          this.appService._components['volume'].frmGroup.get('volume').setValue(response.totalVolume)
        }, (err) => {
          let modal = new Modal({
            action: false, name: 'Volume Calculation', title: 'Volume Calculation', description: 'Invalid JWT. Either expired or not yet valid. Expired JWT', actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);

        });
      } else {
        this.appService._components['volume'].frmGroup.get('volume').setValue('')
      }
}
//end

 //Below function is common for GENERIC_AUTOCOMPLETE_V2, GENERIC_FIELD_V2 & NUMBERBOX_V2 component
  manageAffectedColumn(configData, frmGroup, data, keepAffectedColumnValues = false) {
    let isMatch = false, dependentFieldValue, value: string = "";;
    if (configData['affectedColumns']) {
      for (let i = 0; i < configData['affectedColumns'].length; i++) {
        const element = configData['affectedColumns'][i];
        if (element?.key) element.value.forEach(field => {
          if(field?.dependentFieldName) dependentFieldValue = this.appService?._components[field.dependentFieldName].frmGroup.get(field.dependentFieldName).value || '';
          if (element?.key) isMatch = this.compareValues(element.key, data, configData);
          if (field.action === "SHOW" && isMatch) {
            if (field?.reset && !keepAffectedColumnValues) this.isReset(field, frmGroup);
            frmGroup.get(field.name)['hidden'] = false;
            this.isRequired(field, frmGroup);
            if (field?.enabled) {
              frmGroup.get(field.name).enable();
            }
          } else if (field.action === "HIDE" && isMatch) {
            frmGroup.get(field.name)['hidden'] = true;
            if (field.reset && !keepAffectedColumnValues) this.isReset(field, frmGroup);
          } else if (field.action === "DEPENDENT_FIELD" && this.compareValues(element.key, dependentFieldValue)) {
            if(field.reset && !keepAffectedColumnValues) this.isReset(field, frmGroup);
            if(field?.setData && data[field.setData]) frmGroup.get(field.name).setValue(data[field.setData]); 
            this.isRequired(field, frmGroup);
          } else if (field.action === "SETDATA" && field?.OTMKey) {
            frmGroup.get(field.name)["hidden"] = false;
             if (field?.disable) {
                frmGroup.get(field.name).disable();
              }
            if (field.reset && !keepAffectedColumnValues) this.isReset(field, frmGroup);
            if (field.required) this.isRequired(field, frmGroup);
            if (Array.isArray(field.OTMKey) && !keepAffectedColumnValues) {
              value = field.OTMKey.map(source => this.getFieldValues(source, data)).join(" ");
            } else if(field.OTMKey.includes(".") && !keepAffectedColumnValues) {
              value = this.getFieldValues(field.OTMKey, data);
            } else if (data[field.OTMKey] && !keepAffectedColumnValues) {
              value = data[field.OTMKey];
            }
            if (!keepAffectedColumnValues) {
              const formattedValue = value == null ? "" : value.toString().trim();
              frmGroup.get(field.name).setValue(formattedValue);
            }
            if (field?.component === "GENERIC_AUTOCOMPLETE_V2") frmGroup.get(field.name)['itemArray'].push(data[field.OTMKey]);
          } if (field.action === "SETDATAHEADER" && field?.OTMKey) {
            if (field?.disable) {
              frmGroup.get(field.name).disable();
            }
            if (field.reset && !keepAffectedColumnValues) this.isReset(field, frmGroup);
            if (field.required) this.isRequired(field, frmGroup);
            if (Array.isArray(field.OTMKey) && !keepAffectedColumnValues) {
              value = field.OTMKey.map(source => this.getFieldValues(source, data)).join(" ");
            } else if(field.OTMKey.includes(".") && !keepAffectedColumnValues) {
              value = this.getFieldValues(field.OTMKey, data);
            } else if (data[field.OTMKey] && !keepAffectedColumnValues) {
              value = data[field.OTMKey];
            }
            
            if (!keepAffectedColumnValues && value !== "") {
              const parentFrmGroup = frmGroup.parent.parent;
              const formattedValue = value == null ? "" : value.toString().trim();
              const template = this.appService.getOrderTemplate();
              const control = this.getControlFromJsonTemplate(template, field.name);
              if(field.hasOwnProperty("excludeValue") && !parentFrmGroup.get(field.name).value.includes(field.excludeValue)){
                parentFrmGroup.get(field.name).setValue(formattedValue);
              }
            }
            if (field?.component === "GENERIC_AUTOCOMPLETE_V2") frmGroup.get(field.name)['itemArray'].push(data[field.OTMKey]);
          } else if (field.action === "VOLUME_CALCULATION") {
            if(!keepAffectedColumnValues) this.calculateVolume(field, frmGroup);
          } else if(field.action === "REQUIRED" && isMatch) {
            frmGroup.get(field.name)["hidden"] = false;
            if (field.reset && !keepAffectedColumnValues) this.isReset(field, frmGroup);
            if (field.required) this.isRequired(field, frmGroup);
          } else if (field.action === 'SETDATA' && isMatch) {
              const targetName = field?.name;
              const targetControl = frmGroup.get(targetName);
              if (field?.value) {
                targetControl?.setValue(field?.value);
              }
              if (field?.disable) {
                targetControl?.disable();
              }
            } else if (field.action === 'SET_OTM_DATA' && isMatch && field?.OTMKey) {
              const targetName = field?.name;
              const targetControl = frmGroup.get(targetName);
              setTimeout(() => {
                targetControl?.setValue(data[field.OTMKey]);
              }, 0);
              if (field?.disable) {
                setTimeout(() => {
                  targetControl?.disable();
                }, 0);
              }
            } else if(field.action === "RESET") {
              const targetName = field?.name;
              const targetControl = frmGroup.get(targetName);
              if(!keepAffectedColumnValues) {
                this.isReset(field, frmGroup);
              }
              if (!field?.disable) {
                targetControl?.enable();
              }
              if (field.hidden) {
                targetControl['hidden'] = true;
              }
            } else if(field.action === "ENABLE") {
              const controls = this.findControlsByPath({ formGroup: frmGroup, path: field.name });
              controls.forEach((control) => {
                control?.enable({ emitEvent: false });
              });
            } else if (!isMatch) {
            if (field.reset && !keepAffectedColumnValues) this.isReset(field, frmGroup);
            if (field.action === "SHOW" && !field?.enableShowIfNotMatch) {
              frmGroup.get(field.name)['hidden'] = true;
            }
            frmGroup.get(field.name)['required'] = false;
            frmGroup.get(field.name).removeValidators([Validators.required]);
          }
          frmGroup.get(field.name)?.updateValueAndValidity();
        });
      }
    }
  }

  calculateVolume(eventData, frmGroup) {
    let data = {};

    eventData?.payload.forEach(prop => {
      let val = frmGroup.get(prop).value;
      data[prop] = val;
    })

    if (this.fieldValidationForVolumeCalculation(data) && eventData?.apiURL) {
      let url = eventData?.apiURL + "&customerCode=" + localStorage.getItem('customerCode') + '&userId=' + localStorage.getItem('userName');
      this.appService.makeHttpPostRequest(url, data).subscribe((response: any) => {
        frmGroup.get(eventData.name).setValue(response.totalVolume);
      }, (err) => {
        let modal = new Modal({
          action: false, name: 'Volume Calculation', title: 'Volume Calculation', description: 'Invalid JWT. Either expired or not yet valid. Expired JWT', actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
    } else {
      frmGroup.get(eventData.name).setValue('');
    }
  }

  checkEditAccess(configData, frmGroup) {
    if (configData['editAccess']) {
      configData['editAccess'].forEach(row => {
        let persona;
        if (row.roleAccess) {
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        if (row?.action == 'hidden' && this.checkFieldAccess(persona) == false) {
          frmGroup.get(configData.name)['hidden'] = true;
          configData["required"] = false;
          frmGroup.get(configData.name)['required'] = false;
          frmGroup.get(configData.name).removeValidators([Validators.required]);
        }
        if (row?.required == true && this.checkFieldAccess(persona) == true) {
          configData["required"] = true;
          frmGroup.get(configData.name)['required'] = true;
          frmGroup.get(configData.name).addValidators([Validators.required]);
        }
        if (row?.action == 'disabled') {
          if (this.checkFieldAccess(persona) == false) {
            configData['disabled'] = true;
            frmGroup.get(configData.name).disable();
          }
        }
      });
      frmGroup.get(configData.name).updateValueAndValidity();
    }
  }

  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }

  setAffectedColumnValues(data){
    this.keepAffectedColumnValues = data;
  }
  
  convertUOM(field, value, uom) {
    if (field === 'unitWeight' || field === 'totalWeight' || field === 'actualWeight' || field === 'shipUnitUnitWeight') {
      switch (uom) {
        case 'LB':
          return (value * 0.453592).toFixed(2);
        case 'TON':
          return (value * 1000).toFixed(2);
        case 'KG':
          return (value * 2.20462).toFixed(2);
        case 'MTON':
          return (value * 1000).toFixed(2);
      }
    } else if (field === 'totalVolume' || field === 'actualVolume') {
      switch (uom) {
        case 'CUFT':                            //imperial to default metric vol conversions
          return (value * 0.0283168).toFixed(2);
        case 'CUIN':
          return (value * 0.0000163871).toFixed(2);
        case 'CUYD':
          return (value * 0.764555).toFixed(2);
        case 'CUMTR':                             //metric to default Imperial vol conversions
          return (value * 35.3147).toFixed(2);
        case 'L':
          return (value * 0.0353147).toFixed(2);
      }
    } else {
      switch (uom) {
        case 'IN':
          return (value * 2.54).toFixed(2);
        case 'FT':
          return (value * 30.48).toFixed(2);
        case 'YD':
          return (value * 91.44).toFixed(2);
        case 'CM':
          return (value * 0.393701).toFixed(2);
        case 'MTR':
          return (value * 39.3701).toFixed(2);
        case 'M':
          return (value * 39.3701).toFixed(2);
      }
    }
    if (value === '' || isNaN(value)) {
      return value = '';
    } else {
      return value.toFixed(2);
    }
  }
  processData(resultObject: any, response: any,sortKey: any,sortData: any ): any {
    let dataToSort = response;
    let sortingMode = sortData.sortingMode;
    let sortColumnValue;
    let sortColumnUom;
    let weight;
    let weightUom;
    let volume;
    let volumeUom;

    let convertArr = resultObject?.dataToConvert?.value;
    convertArr?.forEach((item:any) => {
      if(item.key === 'weight' && item?.value && Array.isArray(item.value)){
        [weight, weightUom] = item.value;
      }
      if (item.key === 'volume' && item?.value && Array.isArray(item.value)) {
        [volume, volumeUom] = item.value;
      }
    });

    dataToSort?.orders?.forEach((element: any) => {
      let weightToConvert = element[weight] + " " + element[weightUom];
      let volumeToConvert = element[volume] + " " + element[volumeUom];
      let convertedWeight = this.ConvertUomPipe?.transform(weightToConvert, "");
      let convertedVolume = this.ConvertUomPipe?.transform(volumeToConvert, "");
      console.log("weight",convertedWeight,convertedVolume )
      let weightResult = this.splitValueAndUnit(convertedWeight);
      let volumeResult = this.splitValueAndUnit(convertedVolume);
      element[weight] = weightResult.value ? weightResult.value: "";
      element[weightUom] = weightResult.unit ? weightResult.unit: "";
      element[volume] = volumeResult.value ? volumeResult.value: "";
      element[volumeUom] = volumeResult.unit ? volumeResult.unit: "";
    });

    if (sortKey === resultObject?.title && Object.keys(sortData)?.length !== 0) {
      if (typeof resultObject?.sortColumnAttribute === 'string') {
      sortColumnValue = resultObject.sortColumnAttribute;
    } else if (typeof resultObject?.sortColumnAttribute === 'object') {
      sortColumnValue = resultObject.sortColumnAttribute.key;
    }

      dataToSort?.orders?.sort((a, b) => {
        let volA = parseFloat(a[sortColumnValue]);
        let volB = parseFloat(b[sortColumnValue]);
  
        if (sortingMode === 'ASC') {
          return volA - volB;
        } else if (sortingMode === 'DESC') {
          return volB - volA;
        }
      });
    // }
    return dataToSort;
    }else {
      return dataToSort;
    }
  }

  splitValueAndUnit(value){
    let match = value?.match(/^([0-9.]+)\s*(\w+)$/);
    if(match) {
      return {
        value : match[1],
        unit : match[2]
      };
    }
    return { value :null, unit: null};
  }

  getAffectedColumnValues() {
    return this.keepAffectedColumnValues;
  }

  public notMoreThanValue(check, frmGroup: any, configData: any, fieldGroup: any) {
    let formgroupData = frmGroup.getRawValue(),
      totalItemCount = 0,
      totalHuCount = 0,
      fieldName = check[0].split('_'),
      nextFieldName = check[2].split('_');

    formgroupData[fieldName[0]].forEach(group => {
      if (Object.keys(group).includes(fieldName[1])) {
        totalHuCount += Number(group[fieldName[1]]);
      }
    }, this);

    formgroupData[nextFieldName[0]].forEach(group => {
      if (Object.keys(group).includes(nextFieldName[1])) {
        totalItemCount += Number(group[nextFieldName[1]]);
      }
    }, this);

    if (totalItemCount < totalHuCount) {
      fieldGroup?.controls[0]?.get(configData.name)?.setErrors({ 'maxValue': configData['errorMessage'] });
    } else {
      let shipGroup = frmGroup?.controls[fieldName[0]]['controls'],
        lineGroup = frmGroup?.controls[nextFieldName[0]]['controls'],
        fieldsComp, fieldsArrayGroup;

      for (const comp in shipGroup) {
        fieldsArrayGroup = <UntypedFormGroup>shipGroup[comp];
        if (typeof fieldsArrayGroup === 'object') fieldsComp = fieldsArrayGroup?.get(fieldName[1]);
        if (!isNaN(+comp) && !!fieldsComp?.errors?.maxValue) fieldsComp?.setErrors(null);
      }

      for (const comp in lineGroup) {
        fieldsArrayGroup = <UntypedFormGroup>lineGroup[comp];
        if (typeof fieldsArrayGroup === 'object') fieldsComp = fieldsArrayGroup?.get(nextFieldName[1]);
        if (!isNaN(+comp) && !!fieldsComp?.errors?.maxValue) fieldsComp?.setErrors(null);
      }
    }
  }

  public createFilteredObject(url) {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    let customerName = urlParams.get('customerCode');
    let actionName = urlParams.get('preferenceType') == 'DRAFT_ORDER' ? urlParams.get('preferenceType') : urlParams.get('action');
    const searchString = urlParams.get('searchString');
    if (!customerName)
      customerName = localStorage.getItem("customerCode");
    if (actionName === 'orderListing')
      actionName = 'SEARCH_ORDER';
    let dynamicObject;
    if (JSON.parse(localStorage.getItem('setFiltersValues'))) {
      dynamicObject = JSON.parse(localStorage.getItem('setFiltersValues'));
    } else {
      dynamicObject = {};
    }

    if (!dynamicObject[customerName]) {
      dynamicObject[customerName] = {};
    }

    if (dynamicObject?.[customerName]?.[actionName]?.["URL"]) {
      dynamicObject[customerName][actionName]["URL"] = url;
      dynamicObject[customerName][actionName]["searchString"] = searchString;
    } else {
      dynamicObject[customerName][actionName] = {
        "URL": url,
        "searchString": searchString
      };
    }

    if(!this.isValidURLWithCheck(url)) {
      dynamicObject[customerName][actionName] = {};
    }
    
    localStorage.setItem('setFiltersValues', JSON.stringify(dynamicObject));
  }

  public createLocationObj(field, data) {
    const locationKey = "LOCATION";
    let locationObject = JSON.parse(localStorage.getItem(locationKey)) || {};
    const customerCode = localStorage.getItem("customerCode");
    const actionName = localStorage.getItem("actionName");

    if (!locationObject[customerCode]) {
      locationObject[customerCode] = {};
    }
    if (!locationObject[customerCode][actionName]) {
      locationObject[customerCode][actionName] = {};
    }

    locationObject[customerCode][actionName][field] = data;
    localStorage.setItem(locationKey, JSON.stringify(locationObject));
  }

  public getFilteredObject(Key) {
    let dynamicObject = JSON.parse(localStorage.getItem(Key)),
      customerName = localStorage.getItem('customerCode'),
      actionName = localStorage.getItem('actionName');

    if (dynamicObject?.[customerName]?.[actionName]) {
      return dynamicObject[customerName][actionName];
    }

    return null;
  }

  public setFilteredObject(Key, data) {
    let dynamicObject = JSON.parse(localStorage.getItem(Key)),
      customerName = localStorage.getItem('customerCode'),
      actionName = localStorage.getItem('actionName');

    if (dynamicObject?.[customerName]?.[actionName]) {
      dynamicObject[customerName][actionName] = data
      localStorage.setItem(Key, JSON.stringify(dynamicObject));
    }
  }

  public cloneUnMatchedKeys(sourceObj, targetObj) {
    targetObj = JSON.parse(JSON.stringify(targetObj));
    Object.keys(sourceObj).forEach(key => {
      if (key !== 'URL' && !(key in targetObj)) {
        targetObj[key] = sourceObj[key]?.displayValue ? sourceObj[key].value : sourceObj[key];
      }
    });
    return targetObj;
  }

  public cloneMatchedKeys(sourceObj, targetObj) {
    targetObj = JSON.parse(JSON.stringify(targetObj));
    for (let key in targetObj) {
      if (sourceObj?.[key] && Object.keys(targetObj?.[key]).length > 0) {
        targetObj[key] = sourceObj[key]
      }
    } 
    return targetObj;
  }

  public isValidURLWithCheck(urlString: string): boolean {
    // Check for 'Invalid date' or '[object Object]' in the URL
    if (urlString.includes('Invalid date') || urlString.includes('[object Object]')) {
      console.error("URL contains 'Invalid date' or '[object Object]'");
      return false;
    }
    return true;
  }

  public validateRangeRules(input: string | number, configData: any, frmGroup: any): boolean {
    const sourceValue = this.findControlsByPath({ formGroup: frmGroup, path: configData.dynamicValidationSource })[0]?.value || "";
    const rangeRules = this.filterValidationRules({ rangeRules: configData?.validationV2?.rangeRules || [], targetValue: sourceValue });
    const control = frmGroup.get(configData.name);
    let lastErrorMessage = '';

    for (const rule of rangeRules) {
      let isValid = false;
  
      switch (rule.type) {
        case 'numeric':
          isValid = this.validateNumeric(input, rule);
          break;
            
        case 'alphanumeric':
          isValid = this.validateAlphanumeric(input, rule);
          break;

        case 'regex':
          isValid = this.validateRegex(input, rule);
          break;

        default:
          console.warn(`Unknown validation type: ${rule.type}`);
      }
  
      // If the rule is satisfied, return true and stop further validation
      if (isValid) {
        return true;
      } else {
        lastErrorMessage = rule.errorMessage;
      }
    }
  
    // If no rule is satisfied, set the error on the control and return false
    if (control) {
      control.setErrors({ 'maxValue': lastErrorMessage });
    }
    return false;
  }

  private filterValidationRules({ rangeRules, targetValue = "" }) {
    // Search for a rangeRule with a key that includes the target
    const matchingRule = rangeRules.find((rule) => 
      rule.key && Array.isArray(rule.key) && rule.key.includes(targetValue)
    );
    
    let newRangeRules;
    if (matchingRule) {
      // If there is a match, use the value of that rule
      newRangeRules = matchingRule.value || [];
    } else {
      // If there is no match, use all rules that do NOT have a key
      newRangeRules = rangeRules.filter((rule) => !rule.key);
    }
    
    return newRangeRules;
  }

  public handleConditionalRequired(configData: any, frmGroup: any, isValid: boolean): void {
    const conditionalRequired = configData?.validationV2?.conditionalRequired;
    if (!conditionalRequired?.targetField) return;

    const sourceControl = frmGroup.get(configData.name);
    const targetControl = frmGroup.get(conditionalRequired.targetField);
    
    if (!targetControl) return;

    const condition = conditionalRequired.condition || 'VALID_AND_TOUCHED';
    const shouldBeRequired = condition === 'VALID_AND_TOUCHED'
      ? isValid && sourceControl?.value
      : isValid && sourceControl?.value;

    if (shouldBeRequired) {
      targetControl['required'] = true;
      targetControl.addValidators([Validators.required]);
    } else {
      targetControl['required'] = false;
      targetControl.removeValidators([Validators.required]);
    }
    targetControl.updateValueAndValidity();
  }

  public mapConfigDataControls(configData?: any) {
    if (!configData) return;

    const { groups } = configData;
    if (!groups || groups.length === 0) return;
    
    groups.forEach(({ controls }: { name:string; controls: any[]; }) => {
      controls.forEach(({ name: controlName, ...rest }: { name: string; }) => {
        this.configDataControls[controlName] = rest;
      });
    });
  }

  private validateAtLeastOneFilled({
    fields,
    formGroup,
    errorMessage,
    shouldValidate,
    shouldSubscribe,
  }: {
    fields: { name:string; component: string }[];
    formGroup: UntypedFormGroup;
    errorMessage: string;
    shouldValidate: boolean;
    shouldSubscribe: boolean;
  }): void {
    const fieldsControls = fields.map(({ name, component }) => ({ name, component, control: formGroup.get(name)}));
    const isAnyFieldFilled = fieldsControls.some(({ name, component, control }) => {
      const { value } = control;
      switch (component) {
        case 'TOGGLESWITCH_V2':
          return value === true || value === 'Y';
        case 'DROPDOWN_SIMPLE_V2':
          return Boolean(value?.displayValue && value?.value);
        case 'CHECKBOX_V2':
          return value === true;
        case 'CHIPSAUTOCOMPLETE':
        case 'BUTTONTOGGLE':
          return value?.length > 0;
        default:
          return value !== '';
      }
    });

    fields.forEach(({ name }) => {
      const control = formGroup.get(name);

      if (!control) return;

      if (shouldValidate) {
        if (!isAnyFieldFilled) {
          control.setErrors({ groupValidationError: errorMessage });
          control.markAsTouched();
        } else if (control.hasError('groupValidationError')) {
          control.updateValueAndValidity({ onlySelf: true });
        }
      }

      if (shouldSubscribe) {
        control.valueChanges.subscribe(() => {
          if (formGroup.dirty || formGroup.touched) {
            this.validateAtLeastOneFilled({
              fields,
              formGroup,
              errorMessage,
              shouldValidate: true,
              shouldSubscribe: false,
            });
          }
        });
      }
    });
  }

  private handleAtLeastOneFilledValidation({
    validationConfig,
    formGroup,
    shouldValidate,
    shouldSubscribe,
  }: {
    validationConfig: {
      formArrayName?: string;
      fields: string[];
      type: string;
      errorMessage: string;
    };
    formGroup: UntypedFormGroup;
    shouldValidate: boolean;
    shouldSubscribe: boolean;
  }): void {
    const { formArrayName, fields, errorMessage } = validationConfig;

    if (!formArrayName) {
      const fieldsData = fields.map((field) => {
        return { name: field, component: this.configDataControls[field]?.component };
      });
      this.validateAtLeastOneFilled({ fields: fieldsData, formGroup, errorMessage, shouldValidate, shouldSubscribe });
      return;
    }

    const formArray = formGroup.get(formArrayName) as UntypedFormArray;
    const formArrayControls = formArray?.controls as UntypedFormGroup[];

    formArrayControls?.forEach((arrayFormGroup) => {
      const fieldsData = fields.map((field) => {
        const control = this.configDataControls[formArrayName]?.controls.find(({ name }) => {
          return name === field;
        }) ;
        return { name: field, component: control?.component };
      });
      this.validateAtLeastOneFilled({ fields: fieldsData, formGroup: arrayFormGroup, errorMessage, shouldValidate, shouldSubscribe });
    });
  }

  public clearGroupValidationErrors({ validations, formGroup }: { validations: { fields: string[] }[]; formGroup: UntypedFormGroup }): void {
    if (!validations || validations.length === 0) return;
    validations.forEach(({ fields }) => {
      fields.forEach((field) => {
        const control = formGroup.get(field);
        if (control?.hasError('groupValidationError')) {
          control.setErrors(null);
        }
      });
    });
  }

  public executeGroupValidations({
    validations,
    formGroup,
    shouldValidate = false,
    shouldSubscribe = false,
  }: {
    validations: { type: string; fields: string[]; errorMessage: string; formArrayName?: string }[];
    formGroup: UntypedFormGroup;
    shouldValidate?: boolean;
    shouldSubscribe?: boolean;
  }): void {
    if (!validations || validations.length === 0) return;
    validations.forEach((validation) => {
      switch (validation.type) {
        case 'atLeastOneFilled':
          this.handleAtLeastOneFilledValidation({ validationConfig: validation, formGroup, shouldValidate, shouldSubscribe });
          break;
        default:
          console.warn(`Unknown validation type: ${validation.type}`);
      }
    });
  }

  private validateNumeric(input: string | number, rule: any): boolean {
    if (this.isNumeric(input)) {
      const numericInput = Number(input);
      const min = rule.min !== undefined ? Number(rule.min) : Number.MIN_SAFE_INTEGER;
      const max = rule.max !== undefined ? Number(rule.max) : Number.MAX_SAFE_INTEGER;
      return numericInput >= min && numericInput <= max;
    }
    return false;
  }

  private validateAlphanumeric(input: string | number, rule: any): boolean {
    if (typeof input === 'string' && this.isAlphanumeric(input) && rule.prefix && input.startsWith(rule.prefix)) {
      const numericPart = input.slice(rule.prefix.length);
      const value = Number(numericPart);
      const min = rule.min !== undefined ? Number(rule.min) : Number.MIN_SAFE_INTEGER;
      const max = rule.max !== undefined ? Number(rule.max) : Number.MAX_SAFE_INTEGER;
      return !isNaN(value) && value >= min && value <= max;
    }
    return false;
  }

  private validateRegex(input: string | number, rule: any): boolean {
    if (typeof input === 'string' && rule.pattern) {
      const regex = new RegExp(rule.pattern);
      return regex.test(input);
    }
    return false;
  }

  private isNumeric(value: any): boolean {
    return (
      (typeof value === 'number' && !isNaN(value)) ||
      (typeof value === 'string' && /^[+-]?\d+$/.test(value))
    );
  }

  private isAlphanumeric(value: any): boolean {
    return /^[a-z0-9]+$/i.test(value);
  }

  public isBlank(value: any): boolean {
    return value === "" || (Array.isArray(value) && (value.length === 0 || value.every(item => item === "")))
  }

  public getFieldValues(source: string, data: any): string {
    let value: any = "";
    if (source.includes(".")) {
      const keys = source.split(".");
      for (const key of keys) {
        value = value ? value[key] : data[key];
      }
    } else {
      value = data[source];
    }
    return value !== undefined ? value : "";
  }

  populateFieldsFromUserDetailApi(formGroup, configData) {
    if (!formGroup || !configData) return;

    const { populateFrom } = configData?.validationV2 || {};
    const { source, keys } = populateFrom || {};

    if (!source || !Array.isArray(keys) || keys.length === 0) return;

    const rawData = localStorage.getItem(source);
    let parsedData;

    try {
      parsedData = JSON.parse(rawData);
    } catch {
      parsedData = rawData; // if not JSON, keep as string
    }

    let setValue = '';

    if (typeof parsedData === 'string') {
      // Case 1: plain string
      setValue = parsedData;
    } else if (parsedData && typeof parsedData === 'object' && !Array.isArray(parsedData)) {
      // Case 2: object
      setValue = keys
        .map((key) => parsedData[key] ?? '')
        .filter((value) => value?.toString().trim())
        .join(' ');
    } else if (Array.isArray(parsedData)) {
      // Case 3: array
      setValue = parsedData.filter((v) => v?.toString().trim()).join(' ');
    }

    if (setValue) {
      const control = formGroup.get(configData.name);
      if (control) control.setValue(setValue);
      if (configData.defaultValue) configData.defaultValue.value = setValue;
    }
  }

  safeParse(jsonString) {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error('populateFieldsFromApi: Failed to parse localStorage data:', e);
      return null;
    }
  }

  formatDraftResponseForAccordion(response) {
    let transformed = { ...response.preference };
    Object.keys(transformed).forEach(key => {
      const value = transformed[key];
      if (typeof value === 'object' && value !== null) {
        Object.assign(transformed, value);
        delete transformed[key];
      }
    });
    return transformed;
  }

  getControl(controlName: string , frmGroup): any {
    let control = frmGroup?.get(controlName);
    this.multilevelformGroup = frmGroup; // Default, in case within primary form
  
    if (!control && frmGroup?.parent?.parent instanceof UntypedFormGroup) {
      const parentParentFormGroup =frmGroup.parent.parent;
      control = parentParentFormGroup.get(controlName);
      this.multilevelformGroup = parentParentFormGroup; // Update multilevelformGroup
    }
  
    if (!control && frmGroup?.parent?.parent instanceof UntypedFormGroup) {
      control = this.findControlInFormArrays(frmGroup.parent.parent, controlName);
    }
  
    return { control: control, multilevelformGroup: this.multilevelformGroup };
  }
  
  findControlInFormArrays(parentParentFormGroup: UntypedFormGroup, controlNameToFind: string): any {
    if (parentParentFormGroup?.controls) {
      for (const controlName in parentParentFormGroup.controls) {
        const control = parentParentFormGroup.get(controlName);
        if (control instanceof UntypedFormArray) {
          for (const formGroup of control.controls) {
            if (formGroup instanceof UntypedFormGroup && formGroup.get(controlNameToFind)) {
              this.multilevelformGroup= formGroup  // Update multilevelformGroup
              return formGroup.get(controlNameToFind);
            }
          }
        }
      }
    }
    return null;
  }

  getValuationsAndCountryControls(formGroup,ctrlName) {
    return formGroup?.controls?.LineItem?.controls?.flatMap(lineItem =>
      lineItem?.controls?.accordianComponent?.controls?.flatMap(accordian =>
        accordian?.controls[ctrlName] ? [accordian.controls[ctrlName]] : []
      ) || []
    ) || [];
  }

  findControlFromFrmGroup(key: string, control: AbstractControl): FormControl | null {
    if (control instanceof UntypedFormGroup) {
      for (let controlKey of Object.keys(control.controls)) {
        const ctrl = control.controls[controlKey];
        if (controlKey === key && ctrl instanceof FormControl) {
          return ctrl;
        } else if (ctrl instanceof UntypedFormGroup || ctrl instanceof UntypedFormArray) {
          const found = this.findControlFromFrmGroup(key, ctrl);
          if (found) return found;
        }
      }
    } else if (control instanceof UntypedFormArray) {
      for (let ctrl of control.controls) {
        const found = this.findControlFromFrmGroup(key, ctrl);
        if (found) return found;
      }
    }
    return null;
  }

  // Generic and multi-line level EDOC upload for GSKRD 
  processLineItemDocumentUpload (parentFormGroup: UntypedFormGroup | null, apiResponse: any): void {
    if (!parentFormGroup) {
      console.warn('Parent group not found.');
      return;
    }

    const documentsControl = this.findControlFromFrmGroup('documents', parentFormGroup);
    const docIndexControl = this.findControlFromFrmGroup('docIndex', parentFormGroup);

    const documents = documentsControl?.value || [];
    const index = docIndexControl?.value || "0";

    const existingDocTypeIndex = documents.findIndex(
      (doc: any) => doc.documentType === apiResponse.documentType
    );

    const newDocument = {
      lineItemDocType: `${index}_${apiResponse.documentType}`,
      documentType: apiResponse.documentType,
      documentId: apiResponse.id,
      createdBy: localStorage.getItem('userName'),
      createdOn: new Date().toISOString()
    };

    if (existingDocTypeIndex !== -1) {
      documents[existingDocTypeIndex] = newDocument;
    } else {
      documents.push(newDocument);
    }

    documentsControl?.setValue([...documents]);
  }

  docListingPreview(res) {
    let documentArrayName = res.docPreview;
    if (documentArrayName) {
      documentArrayName.forEach(element => {
        if (element.documentType || element.documentId) {
          let props = res['eventData'].props;
          if (props) {
            props.forEach(comp => {
              if (res.data >= 2) {
                this.appService._components[comp.name].tableRows = this.appService._components[comp.name].tableRows.concat(documentArrayName);
              } else {
                this.appService._components[comp.name].tableRows = documentArrayName;
              }
            })
          }
        }
      })
    }
  }

  validateAccordionFieldsOnSelect(prop: any, configData: any): void {
    const { name, behavior, lineSectionTitle, required, reset } = prop || {};
    if (!name || !behavior || !lineSectionTitle) return;
  
    const componentsList = this.appService._components?.[lineSectionTitle]?.frmGroup?.get(lineSectionTitle)?.controls;
  
    if (!componentsList) return;
  
    const validationList = configData?.validation || [];
    const hiddenIndex = validationList.indexOf("hidden");
  
    componentsList.forEach(comp => {
      const component = this.findControlFromFrmGroup(name, comp);
      if (!component) return;
    
      if (prop?.behavior === 'SHOW') {
        if (required) {
          component['hidden'] = false;
          component['required'] = true;
          component.addValidators?.([Validators.required]);
          configData.required = true;
        }
        if (reset && !this.getAffectedColumnValues()) {
          component.reset?.();
        }
        if (hiddenIndex > -1) validationList.splice(hiddenIndex, 1);
      } else if (prop.behavior === 'HIDE') {
        component['hidden'] = true;
        component['required'] = false;
        component.removeValidators?.([Validators.required]);
        configData.required = false;
        component.reset?.();
        if (hiddenIndex === -1) validationList.push("hidden");
      }
      component.updateValueAndValidity();
    });
  }
  
  restMultilineSection(prop: any): void {
    if (!prop?.name) return;
    let frmControl = this.appService._components[prop.name]?.frmGroup.get(prop.name);
    frmControl.controls.splice(0, frmControl.controls.length);
    let template = this.appService._components[prop.name]?.configData;
    let tempForm = this.formService.simpleFormCreation(template);
    (<UntypedFormArray>frmControl).push(tempForm.controls[0]);
  }

  checkEditAccessRules(frmGroup: FormGroup, configData: any): void {
    const currentUserRole = localStorage.getItem('userRole');
    const currentStatus = localStorage.getItem('gskrdOrderStatus');
    const currentUser = localStorage.getItem('userName');
    const accessRules = configData?.editAccessRules ?? [];

    if (!currentUserRole || !currentStatus || !currentUser || accessRules.length === 0) {
      return;
    }

    for (const rule of accessRules) {
      if (rule?.userRole !== currentUserRole) continue;

      if (rule?.permittedEditors?.length > 0 && !this.isUserCreatorOrRequestor(rule, frmGroup, currentUser)) {
        setTimeout(() => this.disableAllControls(frmGroup), 0);
        return;
      }
    }

    const isRestricted = accessRules.some(rule =>
      rule.userRole === currentUserRole &&
      rule.restrictedStatus?.includes(currentStatus)
    );

    if (isRestricted) {
      setTimeout(() => this.disableAllControls(frmGroup), 0);
    }
  }

  isUserCreatorOrRequestor(rule: any, frmGroup: FormGroup, currentUser: string): boolean {
    return rule?.permittedEditors?.some((fieldName: string) => {
      const control = this.findControlFromFrmGroup(fieldName, frmGroup);
      return control?.value === currentUser;
    }) ?? false;
  }

  disableAllControls(control: AbstractControl): void {
    if (control instanceof FormGroup || control instanceof FormArray) {
      Object.values(control.controls).forEach(child =>
        this.disableAllControls(child)
      );
    } else if (control instanceof FormControl) {
      control.disable({ emitEvent: false });
    }
  }

   controlSubstanceApiResponse(controlSubstanceArray, orderForm, templateData) {
      let formArray
      let ctrlSub = this.formService.findControlFromTemplate(templateData, 'controlSubstance', orderForm)
      let parent
      templateData?.sections?.find(section =>
        section?.groups?.find(group =>
          group?.controls?.find(controlLevel1 =>
            controlLevel1?.controls?.find(controlLevel2 =>
              controlLevel2?.controls?.find(controlLevel3 => {
                if (controlLevel3?.name === "controlSubstanceDetails") {
                  parent = controlLevel3.controls;
                  return true; // Stop searching once found
                }
                return false;
              })
            )
          )
        )
      );
  
      const orderDetails_stepThree = orderForm.controls['orderDetailsStepThree'] as UntypedFormArray
      const orderDetails_stepThreeGroup = orderDetails_stepThree.controls[0] as FormGroup
  
      formArray = this.getValuationsAndCountryControls(orderDetails_stepThreeGroup, 'controlSubstanceDetails')
  
      Object.keys(parent)
        .filter(key => parent[key].name.startsWith('controlSubstance_'))
        .forEach(key => {
          const indexToRemove = parseInt(key);
          parent.splice(indexToRemove);
        });

        for(let i=0 ;i < formArray.length; i++){
          for (const key in formArray[i]?.controls[0].controls) {
            if (key.startsWith("controlSubstance_")) {
              formArray[i].controls[0].removeControl(key);
            }
          }
        }
  
  
      let statusAndMessages = controlSubstanceArray.results.map(item => ({
        gskNumber: item.gskNumber,
        status: item.status,
        message: item.message
      }));
  
      statusAndMessages.forEach((statusAndMessages, index) => {
        const newCtrlSub = { ...ctrlSub };
        newCtrlSub.name = `controlSubstance_${index}`;
        newCtrlSub.label = `Control Substance ${index + 1}`;
        parent.push(newCtrlSub);
        const ctrl1 = this.formService.createFormControl(newCtrlSub);
        for(let i=0 ;i < formArray.length; i++){
          formArray[i].controls[0].addControl('controlSubstance_' + index, ctrl1);
          formArray[i].controls[0].get('controlSubstance_' + index)?.setValue(statusAndMessages.gskNumber);
          formArray[i].controls[0].get('controlSubstance_' + index).hidden = false
  
          if (formArray[i].controls[0].get(newCtrlSub.name)?.value === statusAndMessages.gskNumber && statusAndMessages.status === 'match') {
            newCtrlSub.warningMessage = statusAndMessages.gskNumber + " has been flagged for a potential regulatory issue"
            formArray[i].controls[0].get('shipToApprove').hidden = false
            formArray[i].controls[0].get('shipToApprove').required = true
          }else if(formArray[i].controls[0].get(newCtrlSub.name)?.value === statusAndMessages.gskNumber && statusAndMessages.status === 'nomatch'){
            formArray[i].controls[0].get('shipToApprove').hidden = true
            formArray[i].controls[0].get('shipToApprove').required = false
          }
        }
      });
    }

  public dynamicParameter({ config, value }: { config: { parameter: string; validation: string }[]; value: string }) {
    if (!value || !config || config.length === 0) return null;
    for (const item of config) {
      if (item.validation === 'singleValue' && !value.includes(',')) {
        return { key: item.parameter, value };
      }
      if (item.validation === 'multipleValue' && value.includes(',')) {
        return { key: item.parameter, value };
      }
    }
    return null;
  }

   getControlFromJsonTemplate(temp,name){

    if (!temp) return null;

    if (temp.sections?.length) {
      for (const section of temp.sections) {
        const result = this.getControlFromJsonTemplate(section, name);
        if (result) return result;
      }
    }

    if (temp.groups?.length) {
      for (const group of temp.groups) {
        const result = this.getControlFromJsonTemplate(group, name);
        if (result) return result;
      }
    }
    if (temp.controls?.length) {
      if (temp.name === name) {
        return temp;
      }

      for (const control of temp?.controls) {
        const result = this.getControlFromJsonTemplate(control, name);
        if (result) return result;
      }
    }else if(temp.name === name){
        return temp
    }
  }

  enableInternatinalDomesticForAddLineItem(res){
    res.configData.controls.forEach(ctrl => {
      ctrl.controls.forEach(ChildCtrl =>{
        let originCountryName = this.appService?._components['shipFromCountry']?.frmGroup?.get('shipFromCountry').value 
        let destinationCountryName = this.appService?._components['shipToCountry']?.frmGroup?.get('shipToCountry').value
        let validationList =ChildCtrl.validation || [];
        let hiddenIndex = validationList.indexOf("hidden");
        if(ChildCtrl.name==='ValuationsAndCountry' && originCountryName === destinationCountryName){
          if (hiddenIndex === -1) validationList.push("hidden");
        }else if(ChildCtrl.name==='ValuationsAndCountry' && originCountryName !== destinationCountryName){
          if (hiddenIndex > -1) validationList.splice(hiddenIndex, 1);
        }
      })
    })
  }

  public formGroupHasErrors(formGroup: UntypedFormGroup | undefined): boolean {
    if (!formGroup) return false;

    // Check errors on the formGroup itself
    if (formGroup.errors && Object.keys(formGroup.errors).length > 0) {
      return true;
    }

    // Check errors on controls, if any
    if (formGroup.controls) {
      for (const key of Object.keys(formGroup.controls)) {
        const control = formGroup.get(key);
        if (!control) continue;

        // Check errors on the control itself
        if (control.errors && Object.keys(control.errors).length > 0) {
          return true;
        }

        // Recursively check nested FormGroup
        if (control instanceof UntypedFormGroup) {
          if (this.formGroupHasErrors(control)) {
            return true;
          }
        }

        // Recursively check FormArray
        if (
          (control as any).controls &&
          Array.isArray((control as any).controls)
        ) {
          for (const childControl of (control as any).controls) {
            if (
              (childControl.errors &&
                Object.keys(childControl.errors).length > 0) ||
              (childControl instanceof UntypedFormGroup &&
                this.formGroupHasErrors(childControl))
            ) {
              return true;
            }
          }
        }
      }
    }

    return false;
  }
  controlSubtanceStatusCall(response, uploadControlData) {
    const { isMatch, transactionId } = response.data;
    const { parentFormGroup, statusControlConfig } = uploadControlData

    let url = APP_Constants.MASTER_DATA_STATUS_URL + localStorage.getItem('userName') +
              '&customerCode=' + localStorage.getItem('customerCode') +
              '&transactionId=' + transactionId + '&action=CREATE_ORDER';
    this.appService.makeHttpGetRequest(url).subscribe((statusRes: any) => {
      console.log(statusRes)
      const statusControl = parentFormGroup.get(statusControlConfig.status);
      const messageControl = parentFormGroup.get(statusControlConfig.message);
      const transactionIdControl = parentFormGroup.get(statusControlConfig.transactionId);
      const fileDownloadControl = parentFormGroup.get(statusControlConfig.fileDownload);


      statusControl.setValue(statusRes.data.statusCode);
      messageControl.setValue('-');
      transactionIdControl.setValue(transactionId)
      fileDownloadControl.disable();

      if (statusRes.data.statusCode === 'COMPLETED') {
        if (fileDownloadControl && fileDownloadControl.disabled) {
          fileDownloadControl.enable();
        }
        if (isMatch) {
          messageControl.setValue(statusControlConfig.match);
        } else if (isMatch === false) {
          messageControl.setValue(statusControlConfig.noMatch);
          fileDownloadControl.enable();
        }
        this.appService._commonComponentSubject.next(statusRes?.data?.statusCode);
        clearInterval(this.intervalId);
      }
    })
  }

  controlSubstanceDataUpload(data) {
    this.isFileUpload = true;
    let uploadControl;
    const originCountry = this.appService?._components[data?.statusControlConfig?.shipFrom]?.frmGroup?.get(data?.statusControlConfig?.shipFrom)?.value;
    const destinationCountry = this.appService?._components[data?.statusControlConfig?.shipTo]?.frmGroup?.get(data?.statusControlConfig?.shipTo)?.value;
     uploadControl = data.parentFormGroup.get(data.statusControlConfig.upload);
    let url = APP_Constants.CONTROL_SUB_UPLOAD + localStorage.getItem('userName') +
             '&customerCode=' + localStorage.getItem('customerCode') + '&action=CREATE_ORDER' +
            '&shipToCountry=' + originCountry + '&shipFromCountry=' + destinationCountry + '&orderId=';
    const businessObjectId = this.appService.getOrderDetails()?.data?.businessObject?.businessObjectId;
    const currentUrl = window.location.pathname;
    if (businessObjectId && currentUrl && currentUrl.includes('/orders/' + businessObjectId)) {
      url += businessObjectId;
    }

    let formDataObj: FormData = new FormData();
    if (data?.fileData?.name) {
      let fileName = data?.fileData?.name.split('.')
      let newFileName = fileName[0] + this.appService.getCurrentDateAndTime() + '.' + fileName[1]
        uploadControl.value = data?.fileData?.name;   
      formDataObj.append('filename', data?.fileData, newFileName);
    }
    this.appService.makeHttpPostRequest(url, formDataObj).subscribe(
      (response: any) => {
        if (response) {
          this.isLoading = false;
          this.normalView();
          this.controlSubtanceStatusCall(response, data);
          this.intervalId = setInterval(() => {
            this.controlSubtanceStatusCall(response, data);
          }, 15000)
        }
      },
      (err) => {
        this.isLoading = false;
        this.isFileUpload = false;
        const statusControl = data.parentFormGroup.get(data.statusControlConfig.status);
        const messageControl = data.parentFormGroup.get(data.statusControlConfig.message);
        const transactionIdControl = data.parentFormGroup.get(data.statusControlConfig.transactionId);
        const fileDownloadControl = data.parentFormGroup.get(data.statusControlConfig.fileDownload);
         if (!err?.message?.results) {
          statusControl.setValue('');
          messageControl.setValue('');
        } else if(err?.message?.results) {
          statusControl.setValue('FAILED');
          messageControl.setValue(err?.message?.results[0]);
        }
        transactionIdControl.setValue(null);
        fileDownloadControl.disable();
        this.normalView();
        this.appService._commonComponentSubject.next('');
        clearInterval(this.intervalId);
      }
    )
  }

  openLocationPop(event, templateData, removeLoading) {
    const locationTemplate = templateData?.childTemplate?.locationTemplate;
    const addLocationFormGroup: UntypedFormGroup = this.formService.createForm(locationTemplate);
    const modal = new Modal({
      action: false,
      name: locationTemplate.action,
      title: locationTemplate.title,
      description: locationTemplate.description,
      actionButtonText: "",
      modalForm: {
        type: "common",
        modalName: locationTemplate.action,
        template: locationTemplate,
        frmGroup: addLocationFormGroup,
        editMode: true,
      },
      style: { width: "70%", height: "auto" },
    });

    this.modalService.createModalBox(modal, 200);

    const obsr = this.appService._modalCommonFormSubjecct.subscribe((data) => {
      if (data.name === locationTemplate.action && data.event === "submit") {
        //duplicate cheeck API 
        if (addLocationFormGroup.invalid || addLocationFormGroup?.controls?.addressLine?.errors?.duplicateCheck) {
          this.formService.validateAllFormFields(addLocationFormGroup);
          return;
        }
        this.saveLocation(data.formValue, event, removeLoading);
        obsrUnsubscribe();
      }
      if (data.name === locationTemplate.action && data.event === "cancel") {
        const modalId = `${templateData?.name}-modal`;
        this.locationLeaveDialog({ modalId, afterClose: obsrUnsubscribe, removeLoading });
      }
    });

    const obsrUnsubscribe = () => {
      obsr.unsubscribe();
      this.modalService.closeModel();
      event.component.isOpenAddLocationPoup = false;
    };
  }

  saveLocation(postData, event, removeLoading) {
    const customerCode = localStorage.getItem('customerCode');
    const userId = localStorage.getItem('userName');
    const createLocationURL = `${APP_Constants.CREATE_LOCATION_LINK}${customerCode}&userId=${userId}`;
    this.isLoading = true;
    this.appService.makeHttpPostRequest(createLocationURL, postData).subscribe(
      (response: any) => {
        if (response?.message?.statusCode === APP_Constants.SUCCESS_CODE) {
          const locationId = response?.locationId;
          const primaryValue = `${locationId} -- ${postData.locationName}`;
          const transmissionNo = response?.transmissionNo;
          let times = 0;
          let transmissionStatus;
          let transmissionStatusStatusCode: string;
          setTimeout(() => {
            const getLocationURL = `${APP_Constants.CREATE_LOCATION_TRANSMISSION_STATUS}${customerCode}&orderId=${locationId}&transmissionNo=${transmissionNo}&userId=${userId}`;
            this.appService.makeHttpGetRequest(getLocationURL).subscribe(
              (data) => {
                transmissionStatus = data;
                transmissionStatusStatusCode = transmissionStatus?.message?.statusCode?.toUpperCase();
                if ([APP_Constants.SUCCESS_CODE, APP_Constants.FAILED_CODE].includes(transmissionStatusStatusCode)) {
                  this._snackBar.open({
                    orderId: transmissionStatus?.orderId,
                    message: transmissionStatus?.message?.statusMessage,
                  }, {
                    duration: this.durationInSeconds * 1000
                  });
                  this.setValuesForLocation(event, locationId, primaryValue, postData);
                  removeLoading();
                }
              },
              (error) => {
                const modal = new Modal({
                  action: false,
                  name: 'orderStatus',
                  title: ModalConfigData.TITLES.ORDERSTATUS,
                  description: error.message,
                  actionButtonText: '',
                });
                this.modalService.createModalBox(modal, error.status);
                removeLoading();
              },
            );
            let intervalId = setInterval(() => {
              if (transmissionStatus && [APP_Constants.SUCCESS_CODE, APP_Constants.FAILED_CODE].includes(transmissionStatusStatusCode)) {
                removeLoading();
                clearInterval(intervalId);
              } else if (++times == 5 && transmissionStatus && transmissionStatusStatusCode === APP_Constants.IN_PROGRESS_CODE) {
                this._snackBar.open({
                  orderId: transmissionStatus?.orderId,
                  message: transmissionStatus?.message?.statusMessage,
                }, {
                  duration: this.durationInSeconds * 1000
                });
                removeLoading();
                clearInterval(intervalId);
              } else {
                const locationTransmissionStatusURL = `${APP_Constants.CREATE_LOCATION_TRANSMISSION_STATUS}${customerCode}&orderId=${locationId}&transmissionNo=${transmissionNo}&userId=${userId}`;
                this.appService.makeHttpGetRequest(locationTransmissionStatusURL).subscribe(
                  (data) => {
                    transmissionStatus = data;
                    transmissionStatusStatusCode = transmissionStatus?.message?.statusCode?.toUpperCase();
                    if ([APP_Constants.SUCCESS_CODE, APP_Constants.FAILED_CODE].includes(transmissionStatusStatusCode)) {
                      this._snackBar.open({
                        orderId: transmissionStatus?.orderId,
                        message: transmissionStatus?.message?.statusMessage
                      }, {
                        duration: this.durationInSeconds * 1000
                      });
                      this.setValuesForLocation(event, locationId, primaryValue, postData);
                      removeLoading();
                    }
                  },
                  (error) => {
                    let modal = new Modal({
                      action: false,
                      name: 'addLocationStatus',
                      title: 'Add Location status',
                      description: error.message,
                      actionButtonText: '',
                    });
                    this.modalService.createModalBox(modal, error.status);
                    removeLoading();
                  },
                );
              }
            }, 3000);
          }, 1000);
        }
      },
      (error) => {
        let modal = new Modal({
          action: false,
          name: 'AddLocations',
          title: 'Location Entry',
          description: error.message,
          actionButtonText: '',
        });
        this.modalService.createModalBox(modal, error.status);
        removeLoading();
      },
    );
  }

  locationLeaveDialog({ modalId, afterClose, removeLoading }: { modalId: string, afterClose?: () => void, removeLoading?: () => void }) {
    let config = {
      actions: true,
      name: "Leave",
      title: "Leave Add Location?",
      description: "Changes you made may not be saved.",
      actionButtonText: "Leave",
    };
    const subject = new Subject<boolean>();
    const modalConfirmConfig: MatDialogConfig = new ModalConfig(config);
    modalConfirmConfig.id = modalId;
    const confirmDlg = this.confirmMatDialog.open(
      ModalComponent,
      modalConfirmConfig
    );
    confirmDlg.componentInstance.subject = subject;
    confirmDlg.afterClosed().subscribe(async (response) => {
      if (response) {
        if (afterClose) {
          afterClose();
        }
        if (removeLoading) {
          removeLoading();
        }
      }
    });
  }

  setValuesForLocation(event, locationId, primaryValue, postData) {
    event.component.addNewLocation = false;
    event.component.noItemFound = false;
    if (event.component.configData['secondaryText']) {
      event.component.configData.hintText = 'true';
      event.component.frmGroup.get(event.component.configData.name)['secondaryText'] = postData.addressLine + "," + postData.city + ',' + postData.provinceCode + ',' + postData.postalCode;
    }
    event.component.frmGroup.get(event.component.configData.name).setValue(primaryValue);
    event.component.frmGroup.get(event.component.configData.name + "Id").setValue(locationId);
    event.component.frmGroup.get(event.component.configData.name)['itemArray'].push(primaryValue);
  }

  setSuggestionFormFieldValues(res){
    res.component.frmGroup.enable();
    let primaryText=res.component.frmGroup.get(res.name).value;
    if (res?.configData?.affectedColumns) {
      res?.configData?.affectedColumns.forEach(({ value }) => {
        if (value) {
          value.forEach(({ action, name, editable }) => {
            if (editable) {
              const element = document.querySelector(`#${name}`) as HTMLInputElement;
              if (element && element.readOnly) {
                element.readOnly = false;
              }
            }
            if (action === 'DISABLE') {
              res.component.frmGroup.get(name).disable();
            }
          });
        }
      });
    }
    res.component.frmGroup.reset();
    res.component.frmGroup.get(res.name).setValue(primaryText);
  }

  setFormFieldValues(res) {
    let props = res.eventData.props;
    if (props) {
      props.forEach(comp => {
        if (res.data) {
          let value;
          if (comp.source.includes(".")) {
            let keys = comp.source.split('.');
            for (let k in keys) {
              if (value)
                value = value[keys[k]]
              else
                value = res.data[keys[k]]
            }
          }
          let ctrl = res.component.frmGroup.get(comp.name);
          ctrl.setValue(value);
        }
      })
    }
  }

  addItemIfNotPresent(array, item, key) {
    const isItemPresent = array?.some(record => record[key] === item[key]);
    if (!isItemPresent) {
      array?.push(item);
    }
  }

  //Optimized version of finding the controller in nested deep structure
  findNestedControl(key: string, control: AbstractControl): FormControl | null {
    const stack: AbstractControl[] = [control];

    while (stack.length > 0) {
      const current = stack.pop();

      if (current instanceof UntypedFormGroup) {
        if (current.controls[key] instanceof FormControl) {
          return current.controls[key] as FormControl;
        }

        for (const child of Object.values(current.controls)) {
          stack.push(child);
        }
      }
      else if (current instanceof UntypedFormArray) {
        for (const child of current.controls) {
          stack.push(child);
        }
      }
    }

    return null;
  }

  updatePoSelectAllList(sourceArray, targetArray, key) {
    sourceArray.forEach(item => {
      const found = targetArray.find(t => t[key] === item[key]);
      if (found) {
        found.selected = true;
      } else {
        targetArray.push({ ...item, selected: true });
      }
    });
  }

  enablePOWithOverlapDatedOnly(searchTemplate, selectionArray, row) {
    let dateFormattedColumns = searchTemplate.dateFormattedColumns;
    let isMultiPoDate = Object.values(dateFormattedColumns).filter((val) => (val['multiPoDate'] == 'min' || val['multiPoDate'] == 'max'));
    for (const rule of searchTemplate.bannerDetails.validation) {
      const [firstDateKey, secondDateKey] = rule.split("-isBefore-");
      if (searchTemplate.bannerDetails.validation && isMultiPoDate?.length > 1) {
        let firstDateFormattedColumns = searchTemplate.dateFormattedColumns[firstDateKey];
        let secondDateFormattedColumns = searchTemplate.dateFormattedColumns[secondDateKey];

        let firstArrayOfDateValues = selectionArray.map(val => moment(val[firstDateKey], firstDateFormattedColumns['uiDateFormat']));
        let firstDateValue = firstDateFormattedColumns['multiPoDate'] == 'min' ? moment.min(firstArrayOfDateValues) : moment.max(firstArrayOfDateValues);

        let secondArrayOfDateValues = selectionArray.map(val => moment(val[secondDateKey], secondDateFormattedColumns['uiDateFormat']));
        let secondDateValue = secondDateFormattedColumns['multiPoDate'] == 'min' ? moment.min(secondArrayOfDateValues) : moment.max(secondArrayOfDateValues)

        let isValidFirstDate = moment(firstDateValue, firstDateFormattedColumns['uiDateFormat']).isValid();
        let isValidSecondDate = moment(secondDateValue, secondDateFormattedColumns['uiDateFormat']).isValid();
        if (isValidFirstDate && isValidSecondDate && selectionArray?.length > 0) {
          if (searchTemplate?.overlapDateValidation) {
            const cs = firstDateValue;         // moment object
            const ce = secondDateValue;        // moment object
            const rs = moment(row[firstDateKey], firstDateFormattedColumns['uiDateFormat']);
            const re = moment(row[secondDateKey], secondDateFormattedColumns['uiDateFormat']);
            const overlap = cs.isBefore(re) && rs.isBefore(ce) && !cs.isAfter(ce);
            // Overlap rule: [start, end) => cs < re && rs < ce            // Enable only overlapping rows; disable others
            if (overlap && row?.disabled !== true) {
              row.disabled = false;
            } else if (!overlap) {
              row.disabled = true;
              row.selected = false;
              break;
            }
          } else if (searchTemplate?.iffDateValidation) {
            let fromDateBetween = moment(firstDateValue, firstDateFormattedColumns['uiDateFormat']).format('YYYY-MM-DD')
            let toDateBetween = moment(secondDateValue, firstDateFormattedColumns['uiDateFormat']).format('YYYY-MM-DD')
            let currentDate = moment().format('YYYY-MM-DD');
            let isbetweenDateStatus = moment(currentDate).isBetween(fromDateBetween, toDateBetween, undefined, '[]')
            let isBeforeDateStatus = moment(firstDateValue, firstDateFormattedColumns['uiDateFormat']).isBefore(secondDateValue, secondDateFormattedColumns['uiDateFormat']);
            return { isBeforeDateStatus, isbetweenDateStatus }
          }
        }
      }
    }
  }

  /**
   * Finds controls inside a FormGroup based on a string path.
   *
   * @param params An object containing:
   *   - formGroup: The FormGroup to search from (search always starts at root).
   *   - path: A string representing the path to the control (e.g., "foo", "foo.bar", "foo.bar.baz.3").
   * @returns An array of AbstractControls that match the path.
   */
  public findControlsByPath(params: { formGroup: FormGroup; path?: string }): AbstractControl[] {
    const { formGroup, path } = params;
    if (!formGroup || !path) return [];
    const root = formGroup.root as FormGroup;
    const segments = path.split('.');

    let current: AbstractControl | null = root;

    for (const segment of segments) {
      if (!current) return [];
      // If segment is numeric → index in FormArray
      if (!isNaN(Number(segment))) {
        const index = Number(segment);
        if (current instanceof FormArray) {
          current = current.at(index);
        } else {
          return [];
        }
      } else {
        // Otherwise → treat as FormGroup key
        if (current instanceof FormGroup) {
          current = current.get(segment);
        } else if (current instanceof FormArray) {
          // If current is FormArray, we need to collect from each child group
          const results: AbstractControl[] = [];
          current.controls.forEach((ctrl) => {
            if (ctrl instanceof FormGroup) {
              const child = ctrl.get(segment);
              if (child instanceof FormControl) {
                results.push(child);
              } else if (child instanceof FormArray) {
                results.push(...child.controls);
              }
            }
          });
          return results;
        } else {
          return [];
        }
      }
    }
    // Final resolution
    if (current instanceof FormArray) {
      return current.controls;
    }
    if (current instanceof FormControl) {
      return [current];
    }
    return [];
  }
  public formatInboundOutboundPayload(orderData) {
    if(orderData.param.orderType === 'INBOUND'){
        orderData?.table[0].orderLines.forEach((element:any) => {
          delete element.UOM;
          delete element.WEIGHTUOM;
          delete element.height;
          delete element.length;
          delete element.packageCount;
          delete element.packagingUnit;
          delete element.unitWeight;
          delete element.width;
          element.plantCode = element?.lineItemPlantCode;
          delete element?.lineItemPlantCode;
        });
        orderData?.table[1].shipCard.forEach(element => {
          element.packagingUnit = element.shipUnitPackagingUnit;
          delete element.shipUnitPackagingUnit
          element.packageCount = element.shipUnitPackageCount;
          delete element.shipUnitPackageCount;
          element.length = element.shipUnitLength;
          delete element.shipUnitLength;
          element.width = element.shipUnitWidth;
          delete element.shipUnitWidth;
          element.height = element.shipUnitHeight;
          delete element.shipUnitHeight;
          element.UOM = element.shipUnitUOM;
          delete element.shipUnitUOM;
          element.totalWeight = element.shipUnitUnitWeight;
          delete element.shipUnitUnitWeight;
          element.WEIGHTUOM = element.shipUnitWEIGHTUOM;
          delete element.shipUnitWEIGHTUOM;
        });        
    }
  }

  public bolDownloadFile = (orderId, action?, fileName?, bolUrl?, onComplete?: () => void) => {
    let downloadAPI;
    if(bolUrl){
      downloadAPI = `${bolUrl}VIEW_SCORE_EDOC_DOC&orderId=${orderId}&customerCode=${localStorage.getItem('customerCode')}&userId=${localStorage.getItem('userName')}`;
    }else{ 
      if(action != "VIEW_SCORE_PARCEL_DOC"){
        downloadAPI = `${APP_Constants.BOL_DOWNLOAD_FILE}VIEW_SCORE_EDOC_DOC&orderId=${orderId}&customerCode=${localStorage.getItem('customerCode')}&userId=${localStorage.getItem('userName')}`;
      }else{
        downloadAPI = `${APP_Constants.BOL_DOWNLOAD_FILE}${action}&orderId=${orderId}&customerCode=${localStorage.getItem('customerCode')}&userId=${localStorage.getItem('userName')}`;
      }

    }
    this.appService.makeHttpDocRequest(downloadAPI).subscribe({
      next: (data: any) => {
        if(!fileName){
          fileName = "BOL_Data_";
        }
        fileName += this.appService.getCurrentDateAndTime() + ".pdf";
        let file = new Blob([data], { type: 'application/json' });
        try {
          console.log(data.text() == undefined);
          data.text().then(value => { //convert blob to Json again and check the message.
            let objData = JSON.parse(value)
            if (objData["message"]["statusCode"] == "ERROR") {
              let modal = new Modal({
                action: false, name: 'orderCancelInvalid', title: 'Download File', description: objData["message"]['statusMessage'], actionButtonText: ''
              });
              this.modalService.createModalBox(modal, 'ERROR');
            } else {
              FileSaver.saveAs(data, fileName);//Download here because data is coming in PDF format 
            }
          }).catch(error => {
            FileSaver.saveAs(data, fileName); //Download here because data is coming in PDF format 
          });
        }
        catch (error) {
          console.log(error, "***Connect with TOP BE team***");
        }
        if (onComplete) onComplete();
      },
      error: (err) => {
        if (onComplete) onComplete();
        try {
          err.error.text().then(value => {
            let objData = JSON.parse(value)
            const message = objData['message']['statusMessage'];
            console.log(message, "****BOL Download Error****");
            let modal = new Modal({
              action: false, name: 'orderCancelInvalid', title: 'Download Failed', description: message, actionButtonText: ''
            });
            this.modalService.createModalBox(modal, 'ERROR');
          })
        }
        catch (error) {
          console.log(error, "***Connect with TOP BE team***");
        }

      }
    })
  }


  // Store documentIds
  setDocumentIds(ids: string[]) {
    this.documentIds = ids;
  }

  // Get documentIds
  getDocumentIds(): string[] {
    return this.documentIds || [];
  }

  // Clear documentIds
  clearDocumentIds() {
    this.documentIds = [];
  }

  setRefreshToken(token: string) {
    sessionStorage.setItem('refreshToken', token);
  }

  getRefreshToken(): string {
    return sessionStorage.getItem('refreshToken') || '';
  }

  openUploadDocumentPopUp(event: any, orderId: any): void {
    let uploadDocumentsTemplate = event.eventConfig || event.eventData?.eventConfig || event.configData.events[0].eventConfig;
    this.clearDocumentIds();
    const modalConfig = uploadDocumentsTemplate.modalConfig;
    let uploadDocumentsFormGroup: UntypedFormGroup | undefined;
    const controls = (modalConfig && modalConfig.version === 'v2') ? uploadDocumentsTemplate.modalControls : uploadDocumentsTemplate.contrlols;
    uploadDocumentsFormGroup = this.formService.simpleFormCreation({
      controls: controls
    });

    let modal = new Modal({
      version: modalConfig && modalConfig.version ? modalConfig.version : undefined,
      config: modalConfig || undefined,
      action: false, name: uploadDocumentsTemplate.action, title: uploadDocumentsTemplate.title, description: uploadDocumentsTemplate.description, actionButtonText: '',
      modalForm: { type: "common", modalName: uploadDocumentsTemplate.action, template: uploadDocumentsTemplate, frmGroup: uploadDocumentsFormGroup, editMode: true },
      style: { width: "70%", height: "auto" }
    });
    this.modalService.createModalBox(modal, 200);
    let obsr = this.appService._modalCommonFormSubjecct.subscribe(data => {
      if (data.name == uploadDocumentsTemplate.action && data.event == 'submit') {
        if (uploadDocumentsFormGroup.invalid) {
          this.formService.validateAllFormFields(uploadDocumentsFormGroup);
          return;
        }
        this.uploadDocument(uploadDocumentsTemplate, data.formValue, orderId, () => {
          this.resetAfterFileUploadModal(uploadDocumentsFormGroup, modalConfig, uploadDocumentsTemplate);
          // enable submit button after submitting
          const submitAction = this.checkHasSubmitAction(uploadDocumentsTemplate);
          if (submitAction) {
            submitAction.disabled = false;
          }
        });
        if (modalConfig && modalConfig.keepOpenAfterSubmit) {
          return;
        }
        this.modalService.closeModel();
        obsr.unsubscribe();
      }
      if (data.name == uploadDocumentsTemplate.action && data.event == 'cancel') {
        this.modalService.closeModel();
        obsr.unsubscribe();
      }
    });
  }

  /**
 * Uploads multiple document to backend
 * @param uploadDocumentsTemplate configuration data for document upload coming from template
 * @param formData multiple document upload form data
 */
  uploadDocument(uploadDocumentsTemplate: any, formData: any, orderId: any, callback: () => void): void {
    this.isLoading = false;
    document.getElementById("overlay").style.display = "block";
    if (uploadDocumentsTemplate.modalConfig && uploadDocumentsTemplate.modalConfig.allowInlineMessage) {
      this.appService.showInlineMessage('success', null);
      this.appService.showInlineMessage('error', null);
    }
    // disable submit button when submitting
    const submitAction = this.checkHasSubmitAction(uploadDocumentsTemplate);
    if (submitAction) {
      submitAction.disabled = true;
    }

    this.uploadDocumentGeneratePayload(formData).then((requestPayload) => {
      const uploadDocURL = this.uploadDocumentGenerateURL(uploadDocumentsTemplate.url, uploadDocumentsTemplate.action);
      this.appService.makeHttpPostRequest(uploadDocURL, requestPayload).subscribe((response) => {
        callback();
        this.uploadDocumentHandleSuccess(response, uploadDocumentsTemplate, orderId);
      }, (err) => {
        this.uploadDocumentHandleError(err, uploadDocumentsTemplate);
      });
    });
  }

  /**
   * generates payload for upload document API call
   * @param formData multiple document upload form data
   * @returns payload object as a promise
   */
  async uploadDocumentGeneratePayload(formData: any): Promise<object> {
    const parsedDocumentList = await Promise.all(formData["poLines"].map(this.parseBase64, this));
    return {
      "uploadFileData": parsedDocumentList
    };
  }

  /**
   * prepares URL for document upload with required query parameters
   * @param uploadURL URL endpoint for document upload
   * @param action actin for document upload
   * @returns URL endpoint with query params (for ex: docsservice/uploadDocument?customerCode=FORD&userId=user@dhl.com&action=UPLOAD_DOC)
   */
  uploadDocumentGenerateURL(uploadURL: string, action: string): string {
    let params = {
      customerCode: localStorage.getItem('customerCode'),
      userId: localStorage.getItem('userName'),
      action
    }
    let queryParams = new HttpParams({ fromObject: params });
    return uploadURL + '?' + queryParams.toString();
  }

  /**
     * Converts file content to base64 and generate document payload
     * @param document
     * @returns file base64 string with other attributes as a promise
     */
  parseBase64(document): Promise<Object> {
    return this.appService.getBase64(document.fileUploadSrc).then((base64FileData: string) => {
      return {
        documentType: document.DocumentType,
        filename: document.fileUploadSrc.name,
        attributes: {
          Date: new Date()
        },
        scanAttributes: true,
        data: base64FileData.split(",")[1]  // removes header prefixes
      };
    });
  }

  /**
     * on success of document upload API call show snackbar with success message
     * @param response API success response object
     */
  uploadDocumentHandleSuccess(response: any, uploadDocumentsTemplate: any, orderId: any): void {
    this.isLoading = false;
    // seperate documents based on upload status
    let successfulUploadDocList = response.fileuploadStatus.filter(doc => doc.status === "SUCCESS");
    let failUploadDocList = response.fileuploadStatus.filter(doc => doc.status !== "SUCCESS");

    const existingIds = this.getDocumentIds() || [];

    const newIds = response.fileuploadStatus.map((item: any) => item.documentId);

    const updatedIds = [...existingIds, ...newIds];

    console.log('Final document IDs:', updatedIds);

    this.setDocumentIds(updatedIds);

    // construct a message to display overall status
    let message = '';
    let successDocumentNames = '';
    let errorDocumentNames = '';
    if (successfulUploadDocList.length > 0) {
      successDocumentNames = successfulUploadDocList.map(doc => doc.filename).join(", ");
      message += 'Document uploaded successfully: ' + successDocumentNames + ". ";
    }
    if (failUploadDocList.length > 0) {
      errorDocumentNames = failUploadDocList.map(doc => doc.filename).join(", ");
      message += 'Unable to upload document: ' + errorDocumentNames + ".";
    }

    if (uploadDocumentsTemplate.modalConfig && uploadDocumentsTemplate.modalConfig.allowInlineMessage) {
      if (successfulUploadDocList.length > 0) {
        if (uploadDocumentsTemplate?.instantReleaseFlag) {
          this.appService.showInlineMessage('success', `${successDocumentNames} ${successfulUploadDocList > 1 ? 'have' : 'has'} been uploaded and released successfully.`);
        } else {
          this.appService.showInlineMessage('success', `${successDocumentNames} ${successfulUploadDocList > 1 ? 'have' : 'has'} been uploaded successfully and will be released after order submission.`);
        }
        if (uploadDocumentsTemplate?.instantReleaseFlag) {
          let ids = this.getDocumentIds()
          this.releaseUploadedDocuments(ids, orderId, uploadDocumentsTemplate?.apiConfigForRelease)
        }
      } else {
        this.appService.showInlineMessage('success', null);
      }
      if (failUploadDocList.length > 0) {
        this.appService.showInlineMessage('error', `For ${errorDocumentNames} upload failed, please retry`)
      } else {
        this.appService.showInlineMessage('error', null);
      }
      this.normalView();
      return;
    }
    this.normalView();
  }


  /**
   * on failure of upload document API call show popup with relevant info
   * @param error error object
   * @param uploadDocumentsTemplate configuration data for document upload coming from template
   */
  uploadDocumentHandleError(error: any, uploadDocumentsTemplate: any): void {
    console.error(error);
    this.isLoading = false;
    this.normalView();
    let modal = new Modal({
      action: false,
      name: uploadDocumentsTemplate.name,
      title: uploadDocumentsTemplate.title,
      description: error.message,
      actionButtonText: "",
    });
    this.modalService.createModalBox(modal, error.status);
  }

  checkHasSubmitAction(modalConfigTemplate: any) {
    if (!modalConfigTemplate.modalActions || modalConfigTemplate.modalActions.length === 0) return undefined;
    return modalConfigTemplate.modalActions.find(action => action.type === 'submit');
  }

  resetAfterFileUploadModal(uploadDocumentsFormGroup: UntypedFormGroup, modalConfig: any, uploadDocumentsTemplate: any) {

    // form reset is not required when closing modal
    if (modalConfig && !modalConfig.keepOpenAfterSubmit) {
      return;
    }

    const controls = (modalConfig && modalConfig.version === 'v2') ? uploadDocumentsTemplate.modalControls : uploadDocumentsTemplate.controls;
    const lineItemsControl = controls.find(c => c.type === "items");
    if (!lineItemsControl) return;
    const listItemsFormName = lineItemsControl.name;

    // Remove all line items
    while ((uploadDocumentsFormGroup.get(listItemsFormName) as UntypedFormArray).length !== 0) {
      (uploadDocumentsFormGroup.get(listItemsFormName) as UntypedFormArray).removeAt(0)
    }
    let newFormGroup;
    newFormGroup = this.formService.simpleFormCreation({
      controls: controls
    });

    // Set empty line items
    (newFormGroup.get(listItemsFormName) as UntypedFormArray).controls.forEach(poLineControl => {
      (uploadDocumentsFormGroup.get(listItemsFormName) as UntypedFormArray).push(poLineControl)
    });
    (uploadDocumentsFormGroup.get(listItemsFormName) as UntypedFormArray).controls['deleteButton'] = false;

    setTimeout(() => {
      uploadDocumentsFormGroup.updateValueAndValidity();
    }, 0);
  }

  /**
* Release upload documents in celaton
* @param uploadDocumentsTemplate configuration data for document upload coming from template
* @param formData multiple document upload form data
*/
  releaseUploadedDocuments(ids: any, orderId: any, releaseConfig: any) {
    let refreshToken = this.getRefreshToken();
    let postData = {
      documentIds: ids,
      customerCode: localStorage.getItem('customerCode'),
      userId: localStorage.getItem('userName'),
      action: releaseConfig.action,
      orderId: orderId,
      refreshToken: refreshToken
    }
    this.clearDocumentIds();
    this.appService.makeHttpPostRequest(releaseConfig.apiUrl, postData).subscribe({
      next: (res: any) => {
        this.releaseUploadedDocumentHandleSuccess(res);
      },
      error: (err: any) => {
        this.releaseUploadedDocumentHandleError(err);
      }
    })
  }

  releaseUploadedDocumentHandleSuccess(response: any) {
    let message = "";
    this.isLoading = false;
    if (response) {

      // seperate documents based on release status
      let successfulReleaseDocList = response.fileReleaseStatus.filter(doc => doc.status === "RELEASED_SUCCESSFULLY");
      let failReleaseDocList = response.fileReleaseStatus.filter(doc => doc.status !== "RELEASED_SUCCESSFULLY");

      // construct a message to display overall status
      let successDocumentNames = '';
      let errorDocumentNames = '';
      if (successfulReleaseDocList.length > 0) {
        successDocumentNames = successfulReleaseDocList.map(doc => doc.filename).join(", ");
        message += 'Document released successfully: ' + successDocumentNames + ". ";
      }
      if (failReleaseDocList.length > 0) {
        errorDocumentNames = failReleaseDocList.map(doc => doc.filename).join(", ");
        message += 'Unable to release document: ' + errorDocumentNames + ".";
      }
    } else {
      message = "There are no documents found to release.";
    }

    this.normalView();
  }

  /**
   * Release upload document error handle
   * @param error Error response
   */
  releaseUploadedDocumentHandleError(error: any) {
    this.normalView();
    this.isLoading = false;
    const message = error.message;
    let modal = new Modal({
      action: false,
      name: 'release_upload_documents',
      title: 'Release Uploaded Documents',
      description: message,
      actionButtonText: ''
    });
    this.modalService.createModalBox(modal, error.status);
  }


  
finalReleaseCallValidation(draftdocIds: any) {
  let documentIds: string[] = [];

  const originEU = this.appService?.getOriginUsedLocation();
  const destinationEU = this.appService?.getDestinationUsedLocation();

  const isDomestic =
    originEU.countryCode === destinationEU.countryCode;

  const originIsEU = originEU.importEU === 'Y';
  const destinationIsEU = destinationEU.importEU === 'Y';

  // Mandatory only for international shipments that are not EU→EU
  const isDocUploadMandatory =
    !isDomestic &&
    !(originIsEU && destinationIsEU);

  const draftDocumentIds = draftdocIds || [];
  const uploadedDocumentIds = this.getDocumentIds() || [];

  if (draftDocumentIds.length > 0 && uploadedDocumentIds.length > 0) {
    documentIds = [...draftDocumentIds, ...uploadedDocumentIds];
  } else if (uploadedDocumentIds.length > 0) {
    documentIds = uploadedDocumentIds;
  } else if (draftDocumentIds.length > 0) {
    documentIds = draftDocumentIds;
  }

  const noDocumentsUploaded =
    !documentIds ||
    documentIds.length === 0 ||
    documentIds.every(id => id == null);

  return {
    isValid: !(isDocUploadMandatory && noDocumentsUploaded),
    documentIds
  };


}

}
